/**
 * @license
 * Copyright 2025 Qwen Team
 * SPDX-License-Identifier: Apache-2.0
 */

import type { FC } from 'react';

const Sidebar: FC = () => <aside>Sidebar Component Placeholder</aside>;

export default Sidebar;
